module.exports = __webpack_public_path__ + "static/media/background-tablet.87223e1c.svg";